import { render } from "./RegisterUsageAlert.vue?vue&type=template&id=6179d8d3&scoped=true"
import script from "./RegisterUsageAlert.js?vue&type=script&lang=js"
export * from "./RegisterUsageAlert.js?vue&type=script&lang=js"

import "./RegisterUsageAlert.scss?vue&type=style&index=0&id=6179d8d3&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6179d8d3"]])

export default __exports__